import {toListItemDateString, toListItemDateString1} from "@/utils/dateUtils";
import RpIcon from "@/components/RpIcon";
import {getIconByBizType, getResourceByMcc, getResourceByMccName} from "@/utils/utils";
import {AssetTransItemType} from "./AssetsTransDetail.tsx";
import {useTranslation} from "react-i18next";
import useRenders from '@/hook/useRenders'
import {createStyles, Stack, Box, Typography} from "@mui/material";
import classes from './index.module.less'

export default function AssetsTransItem({record}: { record: AssetTransItemType }) {

  const {t} = useTranslation("translation");

  const {renderAssetLogStatus} = useRenders();

  const _isCardTrans = () => {
    return !!record.cardId;
  }

  const _transTile = () => {
    if (!record) return null;
    if (_isCardTrans()) {
      return (
        <Stack direction="row" alignItems={'center'} gap={'10px'}>
          {_renderIcon(true)}
          <Box>
            <p className={'text-primary'}>{record.businessTypeDisplayName}</p>
            <p className={'tiny'}>{
              toListItemDateString1(record.createTime)
              // `\u2022\u2022\u2022\u2022 ${record.cardLast4}`
            }</p>
          </Box>
        </Stack>
      )

    } else {
      return <Stack direction="row" alignItems={'center'} gap={'10px'}>
        {_renderIcon(false)}
        <Box>
          <span className={'text-primary'}>{record.businessTypeDisplayName}</span>
          <span className={'text-primary'}>{record.businessModuleDisplayName}</span>
        </Box>
      </Stack>
    }
  }

  const _getCardTrans = () => {
    if (_isCardTrans() && record.isRefund === 1) {
      return <span className={'tiny'}>({t('is_refund')})</span>
    } else {
      return <></>;
    }

  }

  const _renderIcon = (isCardTrans: boolean) => {
    if (isCardTrans) {
      let icon = getResourceByMccName(record.merchantName);
      const merchantIcon = icon != null;
      if (!icon) icon = getResourceByMcc(record.mcc);
      let iconEl;
      if (icon) {
        iconEl = <img src={icon}/>
      } else {
        iconEl = <RpIcon icon={"card-info"} size={18}/>
      }

      return merchantIcon ?
        <div>
          {iconEl}
        </div> :
        <div>
          {iconEl}
        </div>;
    } else {
      const icon = getIconByBizType(record.businessType);
      return <div>
        <RpIcon icon={icon ?? 'card-info'} size={18}/>
      </div>
    }
  }

  const getRightContent = () => {
    return (
      <Stack direction="column" className={'text-right'}>
        <p><span className="text-primary">{record.amount}</span><span className={'span'}>{record.varietyCode?.toUpperCase()}</span></p>
        <p><span className={'tiny'}>{renderAssetLogStatus(record.status)}</span>{_getCardTrans()}</p>
      </Stack>
    )
  }

  if (!record) return null;

  return <Box className={classes['flow-container']}>
    <Stack direction="row" justifyContent={'space-between'} alignItems={'center'} className={classes['flow-container-list']}>
      <Box>
        {_transTile()}
      </Box>
      <Box>
        {getRightContent()}
      </Box>
    </Stack>
  </Box>;
}